module.exports = __webpack_public_path__ + "static/village_bgM@2x-1cf2ba804bbf38a718c6c6a0b194a934.png";